export const surgeryData = [
    {
        icd10Code: "K80.0",
        diagnosisDescription: "Calculus of gallbladder with acute cholecystitis",
        procedureCode: "47562",
        procedureDescription: "Laparoscopic cholecystectomy"
    },
    {
        icd10Code: "K35.80",
        diagnosisDescription: "Acute appendicitis",
        procedureCode: "44950",
        procedureDescription: "Appendectomy"
    },
    {
        icd10Code: "N20.0",
        diagnosisDescription: "Kidney stone",
        procedureCode: "50590",
        procedureDescription: "Lithotripsy, extracorporeal"
    },
    {
        icd10Code: "M17.11",
        diagnosisDescription: "Osteoarthritis of right knee",
        procedureCode: "27447",
        procedureDescription: "Total knee arthroplasty (replacement)"
    },
    {
        icd10Code: "M16.11",
        diagnosisDescription: "Osteoarthritis of right hip",
        procedureCode: "27130",
        procedureDescription: "Total hip replacement"
    },
    {
        icd10Code: "C50.911",
        diagnosisDescription: "Breast cancer, right breast",
        procedureCode: "19301",
        procedureDescription: "Lumpectomy"
    },
    {
        icd10Code: "I25.10",
        diagnosisDescription: "Coronary artery disease",
        procedureCode: "33533",
        procedureDescription: "Coronary artery bypass grafting (CABG), single"
    },
    {
        icd10Code: "D25.0",
        diagnosisDescription: "Submucous uterine fibroid",
        procedureCode: "58150",
        procedureDescription: "Total abdominal hysterectomy"
    },
    {
        icd10Code: "K40.20",
        diagnosisDescription: "Inguinal hernia",
        procedureCode: "49505",
        procedureDescription: "Repair of inguinal hernia, initial"
    },
    {
        icd10Code: "L03.115",
        diagnosisDescription: "Cellulitis of right lower limb",
        procedureCode: "11042",
        procedureDescription: "Debridement, skin and subcutaneous tissue"
    },
    {
        icd10Code: "S82.201A",
        diagnosisDescription: "Fracture of tibia shaft",
        procedureCode: "27758",
        procedureDescription: "Open treatment of tibial shaft fracture"
    }
];

export const surgeonList = [
    { id: 101, name: "Dr. Alice Smith" },
    { id: 102, name: "Dr. John Doe" },
    { id: 103, name: "Dr. Rachel Green" },
    { id: 104, name: "Dr. Ross Geller" },
    { id: 105, name: "Dr. Monica Geller" },
    { id: 106, name: "Dr. Chandler Bing" },
    { id: 107, name: "Dr. Joey Tribbiani" },
    { id: 108, name: "Dr. Sheldon Cooper" },
    { id: 109, name: "Dr. Leonard Hofstadter" },
    { id: 110, name: "Dr. Amy Farrah Fowler" },
];

export const assistantSurgeonList = [
    { id: 201, name: "Dr. Sarah Connor" },
    { id: 202, name: "Dr. Kyle Reese" },
    { id: 203, name: "Dr. Ellen Ripley" },
    { id: 204, name: "Dr. Arthur Dent" },
];

export const anesthesiologistList = [
    { id: 301, name: "Dr. Gregory House" },
    { id: 302, name: "Dr. James Wilson" },
    { id: 303, name: "Dr. Lisa Cuddy" },
    { id: 304, name: "Dr. Eric Foreman" },
];

export const nursingStaffList = [
    { id: 401, name: "Nurse Ratched" },
    { id: 402, name: "Nurse Joy" },
    { id: 403, name: "Nurse Jackie" },
    { id: 404, name: "Nurse Carol Hathway" },
];

export const theatreOptions = [
    "OT-1", "OT-2", "OT-3", "OT-4", "OT-5",
    "OT-6", "OT-7", "OT-8", "OT-9", "OT-10"
];

export const allergiesOptions = [
    "Penicillin",
    "Latex",
    "Sulfa drugs",
    "NSAIDs",
    "Iodine",
    "Peanuts",
    "Tree nuts",
    "Shellfish",
    "Milk",
    "Eggs",
    "Soy",
    "Wheat"
];

export const insuranceOptions = [
    "Star Health",
    "HDFC ERGO",
    "ICICI Lombard",
    "Bajaj Allianz",
    "TATA AIG",
    "Niva Bupa",
    "Government Scheme",
    "Other"
];

export const roomNumbers = [
    "101", "102", "103", "104", "105",
    "201", "202", "203", "204", "205",
    "ICU-1", "ICU-2", "ICU-3",
    "General Ward A", "General Ward B"
];
